<!--
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-03-03 18:29:31
 * @Description:
-->
<template>
  <div class="home">
    <NavBar
      :arrow="false"
      :title="
        store.roleId === 0 ? $t('about.title') : $t('navigation.managementplatform')
      "
    >
    </NavBar>
    <div v-if="store.roleId === 1 && store.loginInfo.isData" style="margin-top: 20vh">
      <div class="found bro flex-content" style="padding: 20px 0px 30px">
        <div
          class="flex_item found_box"
          style="padding: 0px"
          @click.prevent="skipModule('/bindingdevice')"
        >
          <!-- 绑定设备 -->
          <svg-icon style="width: 62px; height: 62px" icon-class="bindingdevice" />
          <div class="found_name">{{ $t("Bindingdevice") }}</div>
          <div class="device_tips">*{{ $t("message.Pleasebindthedevicefirst") }}</div>
        </div>
      </div>
      <div class="btn">
        <van-button
          style="color: #ffffff; margin-top: 30px"
          to="/"
          type="primary"
          block
          >{{ $t("logout") }}</van-button
        >
      </div>
    </div>
    <template v-else>
      <!-- 按钮 -->
      <div style="margin: 10px 0px">
        <van-button
          style="color: #666"
          v-if="store.roleId === 0"
          to="/Search?searchType=global"
          type="primary"
          block
          color="#fff"
          ><van-icon name="search" size="16" color="#666" /> {{ $t("agent_name") }}/{{
            $t("company")
          }}/{{ $t("group") }}/{{ $t("users") }}</van-button
        >
        <van-button
          v-else
          style="color: #666"
          to="/Search?searchType=global"
          type="primary"
          block
          color="#fff"
          ><van-icon name="search" size="16" color="#666" /> {{ $t("group") }}/{{
            $t("users")
          }}</van-button
        >
      </div>
      <!-- 头像名称 -->
      <div class="head bro">
        <router-link to="/main">
          <div class="head_left flex-algin relative">
            <van-image width="62" height="62" :src="ptInfo.head_icon" />
            <div class="head_left_box" v-if="store.roleId === 0 && store.agentinfo">
              <div class="head_left_box_name">
                {{ store.agentinfo.agentinfo.contact }}
              </div>
              <div class="head_left_box_title">{{ store.agentinfo.agentinfo.name }}</div>
            </div>
            <div class="head_left_box" v-if="store.roleId === 1 && store.orginfo">
              <div class="head_left_box_name">{{ store.orginfo.orginfo.contact }}</div>
              <div class="head_left_box_title">{{ store.orginfo.orginfo.corg_name }}</div>
            </div>
            <van-image
              class="head-icon"
              width="26"
              height="26"
              :src="require('../assets/test/1.png')"
            />
          </div>
        </router-link>
        <div v-if="store.roleId === 0">
          <!-- :width="120" -->
          <!-- {{ innerWidth }} -->
          <div class="my-swipe flex-algin" v-if="list.length < 3">
            <template v-for="(item, index) in list" :key="index">
              <div class="flex-algin flex_item">
                <div class="flex-algin" style="width: 100%; height: 90px">
                  <div class="my-swipe-item">
                    <div>{{ item.title }}</div>
                    <div>
                      <span class="theme_color">{{ item.num }}</span
                      >{{ $t("pieces") }}
                    </div>
                  </div>
                  <div
                    v-if="index == 0"
                    style="width: 2px; height: 40px; background: rgb(233, 231, 232)"
                  ></div>
                </div>
              </div>
            </template>
          </div>
          <!-- 其他功能开启的时候把注释打开 -->
          <van-swipe
            v-if="innerWidth > 0 && list.length >= 3"
            class="my-swipe"
            @change="onChange"
            :width="innerWidth"
            :height="90"
            :loop="false"
            indicator-color="#68c6c6"
          >
            <van-swipe-item v-for="(item, index) in list" :key="index">
              <div class="flex-algin">
                <div class="my-swipe-item">
                  <div>{{ item.title }}</div>
                  <div>
                    <span class="theme_color">{{ item.num }}</span
                    >{{ $t("pieces") }}
                  </div>
                </div>
                <div
                  v-if="index != list.length - 1"
                  style="width: 2px; height: 40px; background: rgb(233, 231, 232)"
                ></div>
              </div>
            </van-swipe-item>
            <template #indicator>
              <ul class="indicators indicator">
                <li
                  v-for="(item, index) in list"
                  :key="index"
                  :class="{ active: checkActive(index) }"
                ></li>
              </ul>
            </template>
          </van-swipe>
        </div>
      </div>
      <div class="found bro flex-content">
        <div
          class="flex_item found_box"
          v-if="store.roleId === 0"
          @click.prevent="skipModule('/agentAdd')"
        >
          <!-- 代理商 -->
          <van-image width="62" height="62" :src="ptInfo.create_agent_icon" />
          <div class="found_name">{{ $t("navigation.create_agent") }}</div>
        </div>
        <div
          class="flex_item found_box"
          v-if="store.roleId === 0"
          @click.prevent="skipModule('/orgAdd')"
        >
          <!-- 创建单位 -->
          <van-image width="62" height="62" :src="ptInfo.create_org_icon" />
          <div class="found_name">{{ $t("navigation.create_company") }}</div>
        </div>
        <div
          class="flex_item found_box"
          v-if="
            store.roleId === 1 && store.orginfo.orginfo && store.orginfo.orginfo.platform
          "
          @click.prevent="skipModule('/bindingdevice')"
        >
          <!-- 绑定设备 -->
          <!-- <van-image width="62" height="62" :src="ptInfo.create_agent_icon" /> -->
          <svg-icon style="width: 62px; height: 62px" icon-class="bindingdevice" />
          <div class="found_name">{{ $t("Bindingdevice") }}</div>
        </div>
        <div class="flex_item found_box" @click.prevent="skipModule('/groupAdd')">
          <!-- 创建群组 -->
          <van-image width="62" height="62" :src="ptInfo.create_group_icon" />
          <div class="found_name">{{ $t("navigation.create_group") }}</div>
        </div>
      </div>
      <div class="bro" style="margin-bottom: 15px">
        <van-cell
          :value="agentCount"
          v-if="store.roleId === 0"
          :border="false"
          to="/agentList"
          is-link
          class="border-bot flex-algin"
        >
          <template #title>
            <div class="flex-algin">
              <van-image
                class="margins-right"
                width="30"
                height="30"
                :src="ptInfo.agent_icon"
              />
              <div type="primary">{{ $t("navigation.my_agent") }}</div>
            </div>
          </template>
        </van-cell>
        <van-cell
          :value="orgCount"
          v-if="store.roleId === 0"
          :border="false"
          to="/orgList"
          is-link
          class="border-bot flex-algin"
        >
          <template #title>
            <div class="flex-algin">
              <van-image
                class="margins-right"
                width="30"
                height="30"
                :src="ptInfo.org_icon"
              />
              <div type="primary">{{ $t("navigation.my_company") }}</div>
            </div>
          </template>
        </van-cell>
        <van-cell
          :value="groupCount"
          :border="false"
          to="/groupList"
          is-link
          class="border-bot flex-algin"
        >
          <template #title>
            <div class="flex-algin">
              <van-image
                class="margins-right"
                width="30"
                height="30"
                :src="ptInfo.group_icon"
              />
              <div type="primary">{{ $t("navigation.my_group") }}</div>
            </div>
          </template>
        </van-cell>
        <van-cell
          :value="userCount"
          :border="false"
          to="/userList"
          is-link
          class="border-bot flex-algin"
          value-class="flex_one"
        >
          <template #title>
            <div class="flex-algin">
              <van-image
                class="margins-right"
                width="30"
                height="30"
                :src="ptInfo.user_icon"
              />
              <div type="primary">
                {{
                  store.roleId === 0
                    ? $t("navigation.Listofboundcompanyusers")
                    : $t("navigation.my_user")
                }}
              </div>
            </div>
          </template>
        </van-cell>
        <van-cell
          v-if="store.roleId === 0"
          :value="unbind_count"
          :border="false"
          to="/unbounduser"
          is-link
          class="border-bot flex-algin"
          value-class="flex_one"
        >
          <template #title>
            <div class="flex-algin">
              <van-image
                class="margins-right"
                width="30"
                height="30"
                :src="ptInfo.user_icon"
              />
              <div type="primary">{{ $t("navigation.Listofunboundcompanyusers") }}</div>
            </div>
          </template>
        </van-cell>
        <!-- <van-cell
        v-if="store.roleId === 1"
        :border="false"
        to="/patrol"
        is-link
        class="border-bot flex-algin"
        value-class="flex_one"
      >
        <template #title>
          <div class="flex-algin">
            <svg-icon class="svg_icon margins-right" icon-class="patrol_icon" />
            <div type="primary">{{ $t('userPatrol.PatrolManagement') }}</div>
          </div>
        </template>
      </van-cell> -->
        <van-cell
          v-if="store.roleId === 1"
          :border="false"
          to="/fencelist"
          is-link
          class="flex-algin"
        >
          <template #title>
            <div class="flex-algin">
              <svg-icon class="svg_icon margins-right" icon-class="weil" />
              <!-- <van-image class="margins-right" width="30" height="30" :src="require('../assets/test/weil.png')" /> -->
              <div type="primary">{{ $t("navigation.electricfence") }}</div>
            </div>
          </template>
        </van-cell>
        <van-cell
          v-if="store.roleId === 1"
          :border="false"
          to="/recordingList"
          is-link
          class="border-bot flex-algin"
          style="margin-top: 15px"
        >
          <template #title>
            <div class="flex-algin">
              <svg-icon class="svg_icon margins-right" icon-class="soundrecording" />
              <!-- <van-image class="margins-right" width="30" height="30" :src="require('../assets/test/36.png')" /> -->
              <div type="primary">{{ $t("navigation.recording_record") }}</div>
            </div>
          </template>
        </van-cell>
        <van-cell
          v-if="store.roleId === 1"
          :value="sosNumber > 0 ? sosNumber : ''"
          :border="false"
          to="/sosrdingList"
          is-link
          class="border-bot flex-algin"
        >
          <template #title>
            <div class="flex-algin" style="white-space: nowrap">
              <svg-icon class="svg_icon margins-right" icon-class="sos" />
              <!-- <van-image class="margins-right" width="30" height="30" :src="require('../assets/test/sos.png')" /> -->
              <div type="primary">{{ $t("navigation.sos_record") }}</div>
            </div>
          </template>
        </van-cell>
        <van-cell
          v-if="store.roleId === 1"
          :border="false"
          to="/fencerecord"
          is-link
          class="flex-algin"
        >
          <template #title>
            <div class="flex-algin">
              <svg-icon class="svg_icon margins-right" icon-class="yuej" />
              <!-- <van-image class="margins-right" width="30" height="30" :src="require('../assets/test/yuej.png')" /> -->
              <div type="primary">{{ $t("navigation.Electronicfencerecords") }}</div>
            </div>
          </template>
        </van-cell>
      </div>
    </template>
    <!-- 弹出框 -->
    <popup
      :ref="(el) => (popupHef = el)"
      @cancel="cancelCallback"
      @confirm="okCallback"
      :title="$t('hint')"
      :okText="$t('confirm')"
      :cancelText="$t('cancel')"
    >
      <template #content>
        <tips :msg="$t('placeholder.please_rest_password')" style="margin-top: 0"></tips>
      </template>
    </popup>

    <tabbar v-if="store.roleId === 0" :msgCount="msgCount"></tabbar>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar.vue";
import tabbar from "@/components/tabbar.vue";
import {
  getFaststats,
  getAgent,
  getNewUnreadCount,
  untreatedSOSCount,
} from "@/service/user";
import { queryCardSwitch, setPrompt } from "@/service/agent";
import { getFirstBulletin } from "@/service/notice";
import { getOrg, getAssemblyUrl } from "@/service/org";
import {
  reactive,
  toRefs,
  onMounted,
  onBeforeUnmount,
  ref,
  getCurrentInstance,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import gMethod from "@/utils/method";
import permission from "@/utils/permission";

import popup from "@/components/Popups.vue";
import tips from "@/components/tips.vue";

import qs from "qs";

export default {
  name: "HomeView",
  components: {
    NavBar,
    tabbar,
    popup,
    tips,
  },
  setup() {
    const that = getCurrentInstance().appContext.config.globalProperties;
    const router = useRouter();
    const store = useStore().state;
    const $t = store.t;
    const state = reactive({
      agentCount: "",
      orgCount: "",
      groupCount: "",
      userCount: "",
      unbind_count: "", //未绑定用户数量
      ptInfo: {}, //平台信息
      list: [
        {
          title: $t("ptt_card"),
          num: 0,
        },
        {
          title: $t("recording_card"),
          num: 0,
        },
        {
          title: $t("gps_card"),
          num: 0,
        },
        {
          title: $t("sos_card"),
          num: 0,
        },
        {
          title: $t("bounding_card"),
          num: 0,
        },
        // {
        //   title: $t("video_card"),
        //   num: 0
        // },
        {
          title: $t("duplex_card"),
          num: 0,
        },
        // {
        //   title: $t("userPatrol.PatrolCard"),
        //   num: 0,
        // },
      ],
      current: [0, 1],
      sosNumber: 0,
      msgCount: 0,
      reckonbytime: null,
    });
    const innerWidth = ref(0);
    const getDataCount = () => {
      // 获取代理商、单位、群组、用户 数量
      getFaststats({
        access_token: store.loginInfo.access_token,
        openid: store.loginInfo.openid,
      }).then((res) => {
        state.agentCount = res.data.agent_count;
        state.orgCount = res.data.org_count;
        state.groupCount = res.data.group_count;
        state.userCount = res.data.user_count;
        state.unbind_count = res.data.unbind_count;
        sessionStorage.setItem("userCount", state.userCount);
      });
    };

    const getAgentInfo = () => {
      //获取代理商信息
      if (store.roleId === 0) {
        getAgent({
          access_token: store.loginInfo.access_token,
          openid: store.loginInfo.openid,
        }).then((res) => {
          let data = res.data.agentinfo;
          store.isXin = gMethod.interceptUrl(0, data.path);
          if (res.code == 20001) {
            // state.list = [
            //   {
            //     id: 0,
            //     title: $t("ptt_card"),
            //     num: data.blance,
            //   },
            //   {
            //     id: 1,
            //     title: $t("recording_card"),
            //     num: data.recording_card
            //   },
            //   {
            //     id: 2,
            //     title: $t("gps_card"),
            //     num: data.location_card
            //   },
            //   {
            //     id: 3,
            //     title: $t("sos_card"),
            //     num: data.sos_card
            //   },
            //   {
            //     id: 4,
            //     title: $t("bounding_card"),
            //     num: data.enclosure_card
            //   },
            //   // {
            //   //   title: $t("video_card"),
            //   //   num: data.video_card
            //   // }
            //   {
            //     id: 6,
            //     title: $t("duplex_card"),
            //     num: data.duplex_card
            //   }
            // ]
            // if (store.isXin) {
            //   state.list.push({
            //     id: 7,
            //     title: $t("vipcard"),
            //     num: data.super_card
            //   })
            // }
            sessionStorage.setItem("agentInfo", JSON.stringify(res.data));
            store.agentinfo = res.data;
            store.pathmini = res.data.agentinfo.path;
            sessionStorage.setItem("pathmini", store.pathmini);
            getMsgCount(res.data.agentinfo.id);
            getQueryCardSwitch();
            getNotice();

            //判断是否提示 第一次登录修改密码 弹窗：0：未提示，1：已提示
            isPrompt(res.data.prompt);
          }
        });
      } else {
        store.pathmini = "";
        store.isCardSwitch = null;
        sessionStorage.removeItem("isCardSwitchMini");
        sessionStorage.removeItem("pathmini");
      }
    };

    const getQueryCardSwitch = () => {
      if (store.pathmini.length > 4) {
        queryCardSwitch({
          access_token: store.loginInfo.access_token,
          openid: store.loginInfo.openid,
        }).then((res) => {
          sessionStorage.setItem("isCardSwitchMini", JSON.stringify(res.data));
          store.isCardSwitch = res.data;
          state.list = permission.showCardArr(store.agentinfo.agentinfo);
        });
      } else {
        sessionStorage.removeItem("isCardSwitchMini");
        store.isCardSwitch = null;
        state.list = permission.showCardArr(store.agentinfo.agentinfo);
      }
    };

    const getOrgInfo = () => {
      //获取单位信息
      if (store.roleId === 1) {
        getOrg({
          access_token: store.loginInfo.access_token,
          openid: store.loginInfo.openid,
        }).then((res) => {
          if (res.code == 20001) {
            sessionStorage.setItem("orgInfo", JSON.stringify(res.data));
            store.orginfo = res.data;

            //判断是否提示 第一次登录修改密码 弹窗：0：未提示，1：已提示
            isPrompt(res.data.prompt);
          }
        });
        getAssemblyUrl({
          access_token: store.loginInfo.access_token,
          openid: store.loginInfo.openid,
        }).then((res) => {
          if (res.code == 20001) {
            console.log(res);
            let listUrl = res.data;
            for (var i = 0; i < listUrl.length; i++) {
              if (listUrl[i].server_type == "enclosure") {
                let url = listUrl[i].intranet_ip + ":" + listUrl[i].intranet_port;
                store.orgFenceUrl = url;
                store.fenceUrlDk = `http://${url}/electronicFence/list`;
                sessionStorage.setItem("orgFenceUrl", url);
              }
            }
          }
        });

        if (!store.loginInfo.isData) {
          sosCount();
          state.reckonbytime = setInterval(() => {
            sosCount();
          }, 3000);
        }
      }
    };

    const sosCount = () => {
      untreatedSOSCount({
        access_token: store.loginInfo.access_token,
        openid: store.loginInfo.openid,
      }).then((res) => {
        state.sosNumber = parseInt(res);
      });
    };

    const getMsgCount = (id) => {
      getNewUnreadCount({
        access_token: store.loginInfo.access_token,
        openid: store.loginInfo.openid,
        agentId: id,
      }).then((res) => {
        state.msgCount = res.count;
      });
    };

    const checkActive = (index) => {
      let bool = state.current.some((item) => item == index);
      return bool; // current为监听的轮播index
    };

    const skipModule = (path) => {
      if (
        store.roleId === 1 &&
        store.orginfo &&
        store.orginfo.orginfo.platform == 1 &&
        path == "/groupAdd" &&
        state.userCount <= 0
      ) {
        return that.showDialogMsg($t("message.Failedtocreategrouppleasebinddevicefirst"));
      }
      //跳转模块showDialogMsg
      router.push({ path: path });
    };

    const onChange = (index) => {
      //监听轮播 change 事件
      let num = state.list.length - index;
      // let arr = [index, index + 1, index + 2];
      let arr = [index, index + 1];
      if (num <= 2) {
        arr = [index - 1, index];
      }
      state.current = [];
      state.current = arr;
    };
    const onResize = () => {
      //更新宽度
      innerWidth.value = 0;
      setTimeout(() => {
        innerWidth.value = window.innerWidth / 2 - 15;
      }, 100);
    };

    const getNotice = () => {
      //获取最新公告
      getFirstBulletin({
        access_token: store.loginInfo.access_token,
        openid: store.loginInfo.openid,
        agentId: store.agentinfo.agentinfo.id,
        path: store.agentinfo.agentinfo.path,
        isNewBulletin: 0,
      }).then((res) => {
        if (res.code == 20001) {
          if (res.data && res.data[0]) {
            router.push({
              path: `/system_notice`,
              query: { noticeDetail: JSON.stringify(res.data[0]) },
            });
          }
        } else {
          that.showToastMsg(res.msg[store.langMsg]);
        }
      });
    };

    const popupHef = ref();

    //设置第一次登录，修改弹窗
    const isPrompt = (prompt) => {
      if (prompt == 0) {
        popupHef.value.isShow = true;

        let params = {
          access_token: store.loginInfo.access_token,
          openid: store.loginInfo.openid,
        };
        setPrompt(qs.stringify(params)).then((res) => {
          if (res.code == 20001) {
            console.log("弹窗修改为：已提示");
          }
        });
      }
    };

    //关闭
    const cancelCallback = () => {
      popupHef.value.isShow = false;
    };

    //点击确认跳转重置密码页面
    const okCallback = () => {
      popupHef.value.isShow = false;
      router.push({
        path: "/changePwd",
      });
    };

    onMounted(() => {
      state.ptInfo = store.ptInfo;
      getDataCount();
      getAgentInfo();
      getOrgInfo();
      onResize();
      window.addEventListener("resize", onResize);
    });

    onBeforeUnmount(() => {
      if (state.reckonbytime) {
        clearInterval(state.reckonbytime);
      }
    });
    return {
      ...toRefs(state),
      checkActive,
      onChange,
      store,
      innerWidth,
      skipModule,
      cancelCallback,
      okCallback,
      isPrompt,
      popupHef,
    };
  },
};
</script>

<style scoped lang="less">
.home {
  width: calc(100vw - 30px);
  // height: 100vh;
  min-height: 100vh;
  background-color: #ededed;
  padding: 0px 15px;
}

.head {
  width: 100%;
  background-color: #ffffff;

  &_left {
    font-size: 15px;
    padding: 15px 25px 10px 25px;

    &_box {
      max-width: 150px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-left: 15px;

      &_name {
        color: rgb(62, 62, 62);
        font-weight: bold;
      }

      &_title {
        color: rgb(196, 209, 215);
      }
    }
  }

  &-icon {
    position: absolute;
    right: 30px;
    top: 35%;
  }
}

.found {
  background-color: #ffffff;
  margin: 10px 0px;
  font-size: 15px;

  &_box {
    text-align: center;
    padding: 10px;
  }

  &_name {
    height: 36px;
  }
}

.my-swipe {
  width: 100%;
  font-size: 15px;
  // /deep/.van-swipe__track{
  //   width: 100% !important;
  // }
}

.my-swipe .van-swipe-item {
  // width: calc(100% / 6 / 3 + 0.5px) !important;
  color: #000;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  background-color: #ffffff;
}

.my-swipe-item {
  width: 100%;
  text-align: center;
}

.indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  display: flex;
  transform: translateX(-50%);
}

.indicator li {
  display: inline;
  width: 8px;
  height: 8px;
  background-color: #e1e1e1;
  border-radius: 50%;
  opacity: 1;
  transition: opacity 0.5s,
    //@animation-duration-fast
    background-color 0.5s; //@animation-duration-fast

  &:not(:last-child) {
    margin-right: 6px;
  }

  &.active {
    background-color: var(--main-bg-color);
    opacity: 1;
  }
}

.svg_icon {
  width: 30px;
  height: 30px;
}

.btn /deep/.van-button {
  background-color: var(--main-bg-color) !important;
  border-color: var(--main-bg-color) !important;
}

.device_tips {
  color: red;
  font-size: 14px;
}
</style>
